"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@folio/stripes/components");
var _EditSettingValue = _interopRequireDefault(require("./EditSettingValue"));
var _RenderSettingValue = _interopRequireDefault(require("./RenderSettingValue"));
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _utils = require("../../utils");
var _renderHelpText = _interopRequireDefault(require("../../../../styles/renderHelpText.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SettingField = settingFieldProps => {
  const {
    allowEdit = true,
    editing,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    onSave,
    setEditing,
    settingData: {
      currentSetting
    } = {}
  } = settingFieldProps;
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  const {
    refdataEndpoint,
    templateEndpoint
  } = (0, _react.useContext)(_contexts.SettingsContext);
  const {
    0: {
      values: refdata = []
    } = {}
  } = (0, _hooks.useRefdata)({
    endpoint: refdataEndpoint,
    desc: currentSetting.vocab,
    queryParams: {
      enabled: !!currentSetting?.vocab && currentSetting.settingType === 'Refdata',
      staleTime: 1000 * 60 * 2 // 2 minutes staletime for refdata in settings?
    }
  });
  const templates = (0, _hooks.useTemplates)({
    context: currentSetting.vocab,
    endpoint: templateEndpoint,
    queryParams: {
      enabled: !!currentSetting?.vocab && currentSetting.settingType === 'Template'
    }
  });
  const renderHelpText = helpTextId => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _renderHelpText.default.help,
      children: kintIntl.formatKintMessage({
        id: helpTextId
      }, {
        b: chunks => /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
          children: chunks
        }),
        i: chunks => /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
          children: chunks
        }),
        em: chunks => /*#__PURE__*/(0, _jsxRuntime.jsx)("em", {
          children: chunks
        }),
        strong: chunks => /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
          children: chunks
        }),
        span: chunks => /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: chunks
        }),
        div: chunks => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: chunks
        }),
        p: chunks => /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: chunks
        }),
        ul: chunks => /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
          children: chunks
        }),
        ol: chunks => /*#__PURE__*/(0, _jsxRuntime.jsx)("ol", {
          children: chunks
        }),
        li: chunks => /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          children: chunks
        })
      })
    });
  };
  const renderEditButton = () => {
    const EditText = editing ? kintIntl.formatKintMessage({
      id: 'save'
    }) : kintIntl.formatKintMessage({
      id: 'edit'
    });
    if (allowEdit) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        marginBottom0: true,
        onClick: e => {
          e.preventDefault();
          return editing ? onSave().then(() => setEditing(false)) : setEditing(true);
        },
        children: EditText
      });
    }
    return null;
  };
  let RenderFunction;
  if (editing === false) {
    RenderFunction = _RenderSettingValue.default;
  } else {
    RenderFunction = _EditSettingValue.default;
  }
  const id = `settings.${(0, _utils.toCamelCase)(currentSetting.section)}.${(0, _utils.toCamelCase)(currentSetting.key)}.help`;
  const renderHeaderStart = () => {
    const settingName = Object.keys(currentSetting).length > 0 ? kintIntl.formatKintMessage({
      id: `settings.${(0, _utils.toCamelCase)(currentSetting.section)}.${(0, _utils.toCamelCase)(currentSetting.key)}`
    }) : kintIntl.formatKintMessage({
      id: 'loading'
    });
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [kintIntl.messageExists(id) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.InfoPopover, {
        content: renderHelpText(id)
      }), settingName]
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Card, {
    headerEnd: renderEditButton(),
    headerStart: renderHeaderStart(),
    roundedBorder: true,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(RenderFunction, {
      currentSetting: currentSetting,
      intlKey: passedIntlKey,
      intlNS: passedIntlNS,
      labelOverrides: labelOverrides,
      refdata: refdata,
      templates: templates,
      ...settingFieldProps
    })
  });
};
SettingField.propTypes = {
  allowEdit: _propTypes.default.bool,
  settingData: _propTypes.default.shape({
    refdatavalues: _propTypes.default.arrayOf(_propTypes.default.object),
    currentSetting: _propTypes.default.object,
    templates: _propTypes.default.arrayOf(_propTypes.default.object)
  }),
  input: _propTypes.default.object,
  onSave: _propTypes.default.func
};
var _default = exports.default = SettingField;